module.exports = __webpack_public_path__ + "img/live_bbin.bd45b18a.png";